import request from './../util/request'
//获取分享配置
export function queryShareConfig(data) {
  return request({
    url: '/v2/tableShare/getTableShareConfig',
    method: 'post',
    data
  })
}
//分享页面获取分享配置
export function getShareConfig(data) {
  return request({
    url: '/v2/tableShare/pub/getTableShareConf/'+data.shareId,
    method: 'get',
  })
}
//校验分享密码
export function checkPassword(data) {
  return request({
    url: '/v2/tableShare/pub/checkPassword',
    method: 'post',
    data
  })
}
//获取分享页面的信息
export function getShareComponent(data) {
  return request({
    url: '/v2/tableShare/pub/getShareColumns',
    method: 'post',
    data
  })
}
//分享页面创建任务
export function createShareTask(data) {
  return request({
    url: '/v2/tableShare/pub/createShare',
    method: 'post',
    data
  })
}
//分享页面编辑保存任务
export function editShareTask(data) {
  return request({
    url: '/v2/tableShare/pub/updateShare/' + data.shareId,
    method: 'post',
    data
  })
}
//分享页面获取任务数据
export function queryTaskByIdOfShare(data) {
  return request({
    url: '/v2/tableShare/pub/getUpdateTaskDetailByShare/' + data.shareId + '/' + data.taskId,
    method: 'get',
  })
}
//分享页面获取密码随机数
export function queryRandomNum(data) {
  return request({
    url: '/v2/basic/randomNum/' + data.length,
    method: 'get',
  })
}
//分享页面设置查询条件
export function operationCondition(data) {
  return request({
    url: '/v2/tableShare/operationCondition',
    method: 'post',
    data
  })
}
//分享页面根据条件查询任务
export function queryShareTask(data) {
  return request({
    url: '/v2/tableShare/pub/queryShare/' + data.shareId,
    method: 'post',
    data
  })
}
//分享页面根据条件查询任务-操作日志
export function queryShareTaskRecord(data) {
  return request({
    url: '/v2/tableShare/pub/selectLogsByTargetId/' + data.shareId + '/' + data.taskId,
    method: 'get',
    data
  })
}
//分享页面创建任务唯一值查询
export function checkOnly(data) {
  return request({
    url: '/v2/tableShare/pub/duplicateValueByShare',
    method: 'post',
    data
  })
}

//获取工作表相关的规则：任务截止时间、组件显隐、组件计算
export function queryProjectRule(data) {
  return request({
    url: '/v2/tableShare/pub/getColumnRule/'+data.shareId+'/'+data.type,
    method: 'get',
  })
}

//获取内部数据源选项条件
export function queryInsideDataSourceInfo(data) {
  return request({
    url: '/v2/tableShare/pub/getInsideInfo',
    method: 'post',
    data
  })
}
// //获取群组中组件的详细信息
// export function getComponentData(data) {
//   return request({
//     url: '/v2/project/column/getColumnById',
//     method: 'post',
//     data
//   })
// }
// H5-根据服务大厅id获取服务大厅详情
export function getServiceHallByServerId(data) {
  return request({
    url: '/v2/serviceHall/getServiceHallByServerId',
    method: 'post',
    data
  })
}

// H5-服务大厅-知识类服务-知识详情
export function getKnowledgeDetail(data) {
  return request({
    url: `v2/knowledge/share/`+data.id,
    method: 'get',
  })
}

// h5打开分享埋点接口
export function serviceHallGeneralConfig(data) {
  return request({
    url: `/v2/serviceHall/general/config?device=h5`,
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/share.js